import { Col, Form, Radio, Row, Select } from "@pankod/refine-antd";
// import { IAttachment } from "interfaces"; // TODO: uncomment when field-driven config is implemented

export type SawAssetConfigProps = {
  makeModel?: string[];
  resolution?: string[];
  // fields?: IAttachment[]; // dead code path: retained for future metadata-driven expansions
  disabled?: boolean;
};

export const EditSawAssetConfig: React.FC<SawAssetConfigProps> = ({ makeModel, resolution, disabled = false }) => {
  // Layout mirrors asset module responsive behavior
  const twoColumnLayout = {
    xs: { span: 24 },
    sm: { span: 24 },
    md: { span: 12 },
    lg: { span: 12 },
    xl: { span: 12 },
    xxl: { span: 12 },
  };
  const rowGutter = { xs: 8, sm: 16, md: 24, lg: 32, xl: 40, xxl: 48 };

  const makeModelOptions = Array.isArray(makeModel) ? [...makeModel] : [];
  const resolutionOptions = Array.isArray(resolution) ? [...resolution] : [];

  const hasMakeModel = makeModelOptions.length > 0;
  const hasResolution = resolutionOptions.length > 0;
  if (hasMakeModel) {
    makeModelOptions.sort((a, b) => a.localeCompare(b));
  }

  return (
    <>
      <Row gutter={rowGutter}>
        {hasMakeModel && (
          <Col className="gutter-row" {...twoColumnLayout}>
            <Form.Item
              label="Make/Model"
              name="makeModel"
              rules={[{ required: true, type: "string" }]}
            >
              {makeModelOptions.length > 5 ? (
                <Select
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option: any) =>
                    option?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  filterSort={(a, b) =>
                    a?.children?.toLowerCase().localeCompare(b?.children?.toLowerCase())
                  }
                  disabled={disabled}
                >
                  {makeModelOptions.map((m, i) => (
                    <Select.Option value={m} key={i}>
                      {m}
                    </Select.Option>
                  ))}
                </Select>
              ) : (
                <Radio.Group
                  optionType="button"
                  buttonStyle="solid"
                  options={makeModelOptions}
                  disabled={disabled}
                />
              )}
            </Form.Item>
          </Col>
        )}

        {hasResolution && (
          <Col className="gutter-row" {...twoColumnLayout}>
            <Form.Item
              label="Resolution"
              name="resolution"
              rules={[{ required: true, type: "string" }]}
            >
              <Radio.Group
                optionType="button"
                buttonStyle="solid"
                options={resolutionOptions}
                disabled={disabled}
              />
            </Form.Item>
          </Col>
        )}
      </Row>
    </>
  );
};
